document.addEventListener('DOMContentLoaded', () => {
	const frm = document.getElementById('formLogout')

	if (frm) {
		frm.addEventListener('submit', async evt => {
			evt.preventDefault();
			const url = '/de/zugang';
			await fetch(url, {
				method: 'DELETE'
			});
			window.location.replace(url); // since the session is no longer valid, load login page, which is then redirected by php
		});
	}
})